module.exports = __webpack_public_path__ + "img/gongneng.b9d672b2.png";